import { Icon } from '@ihsm/ui-shared';
import React from 'react';
import { ToastCloseButtonProps } from '../types';
import './ToastCloseButton.scss';

export const ToastCloseButton = ({
  closeToast,
}: ToastCloseButtonProps): JSX.Element => (
  <button className="toast-close-button" type="button" onClick={closeToast}>
    <Icon source="Close" />
  </button>
);
